import React, { useState, useRef } from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import ItemSearchPopup from "./ItemSearchPopup";
import {
  Container,
  TextField,
  Grid,
  Box,
  Button,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Divider,
  TableRow,
  Checkbox,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  FormControl,
  InputLabel,
  Accordion,
  AccordionSummary,
  Select,
  AccordionDetails,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Swal from "sweetalert2";
import useFetch from "../utils/UseFetch";
import { Buffer } from "buffer";
import { useLocation } from "react-router-dom";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import axios from "axios";
import { Row, Col } from "reactstrap";
import { base64ToBlob, convertFileToBase64 } from "../HelperFx/common.js";
import { bidHeader, base64backendtoken } from "../utils/DataLinks.jsx";

const REACT_APP_API_USERNAME = process.env.REACT_APP_API_USERNAME;
const REACT_APP_API_PASSWORD = process.env.REACT_APP_API_PASSWORD;
const REACT_APP_EXPRESS_SERVER = process.env.REACT_APP_EXPRESS_SERVER;
const REACT_APP_COMPANY = process.env.REACT_APP_COMPANY;
const REACT_APP_API_DATA_URL = process.env.REACT_APP_API_DATA_URL;
const REACT_APP_BIDDING_API_DATA_URL =
  process.env.REACT_APP_BIDDING_API_DATA_URL;

const REACT_UNAME = REACT_APP_API_USERNAME;
const REACT_PWD = REACT_APP_API_PASSWORD;
const REACT_DATA_URL = REACT_APP_API_DATA_URL;
const REACT_APP_COMPANY_URL = REACT_APP_COMPANY;

const ApplyBidDetailsPage = () => {
  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState("");
  const [searchColumn, setSearchColumn] = useState("no");
  const [openPreview, setOpenPreview] = useState(false);
  const [loginstatus, setLoginStatus] = useState(false);
  const [exchangeRate, setExchangeRate] = useState(1);
  const [userData, setUserData] = useState(null);
  const [errorUserData, setError] = useState(null);
  const [selectedFile, setSelectedFile] = useState([]);
  const [newSelectedFile, setNewSelectedFile] = useState([]);
  const fileInputRef = useRef(null);

  const componentRef = useRef(null); // Changed ref name for clarity

  const token = Buffer.from(`${REACT_UNAME}:${REACT_PWD}`, "utf8").toString(
    "base64",
  );
  // const vendorNo = sessionStorage.getItem('vendorNo');

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const storedEmail = sessionStorage.getItem("email");
        if (!storedEmail) {
          throw new Error("No email found in local storage");
        }

        const response = await fetch(
          `${REACT_APP_EXPRESS_SERVER}/profile/${storedEmail}`,
        );
        if (!response.ok) {
          throw new Error("Failed to fetch user profile");
        }

        const data = await response.json();
        setUserData(data);
      } catch (err) {
        setError(err.message);
      } finally {
      }
    };
    fetchUserProfile();
  }, []);

  const {
    data: BidHeader,
    Bidloading,
    Biderror,
  } = useFetch(
    `${bidHeader}&$filter=no eq '${location.state?.bidNo}'`,
    base64backendtoken,
  );

  const lvBidHeader = BidHeader?.value[0] || {};
  console.log(lvBidHeader);

  const {
    data: itemsLines,
    loading,
    error,
  } = useFetch(
    `${REACT_DATA_URL}bidlines?${REACT_APP_COMPANY_URL}&$filter=documentNo eq '${location.state?.bidNo}'`,
    token,
  );

  const [lines, setLines] = useState([
    {
      type: "Item",
      no: "",
      description: "",
      productLot: "",
      quantity: "",
      uom: "",
      price: "",
      unitCost: "",
      lineAmount: "",
      systemId: "",
    },
  ]);

  const itemsLinesData = itemsLines?.value;

  console.log(itemsLinesData);

  useEffect(() => {
    if (location.state?.bidNo !== null) {
      if (location.state?.bidNo) {
        const linesData =
          itemsLinesData?.length > 0
            ? itemsLinesData.map((line) => ({
                type: line.type,
                no: line.no,
                description: line.description,
                productLot: line.productLot,
                quantity: line.quantity,
                unitCost: line.unitCost,
                uom: line.uom,
                lineAmount: line.lineAmount,
                price: "",
                systemId: line.id,
              }))
            : [
                {
                  type: "Item",
                  no: "",
                  systemId: "",
                  description: "",
                  productLot: "",
                  quantity: "",
                  unitCost: "",
                  uom: "",
                  lineAmount: "",
                  price: "",
                },
              ];
        setLines(linesData);
        linesData.push({
          type: "Item",
          no: "",
          description: "",
          systemId: "",
          productLot: "",
          quantity: "",
          unitCost: "",
          lineAmount: "",
          uom: "",
          price: "",
        });
      }
    }
  }, [itemsLinesData, location.state?.bidNo]);

  const filteredItems =
    itemsLinesData?.filter((item) =>
      item[searchColumn]
        ?.toString()
        .toLowerCase()
        .includes(searchQuery.toLowerCase()),
    ) || [];

  const {
    data: BidLinesItemsData,
    bidLinesloading,
    bidLinesError,
  } = useFetch(
    `${REACT_DATA_URL}RFPLines?${REACT_APP_COMPANY_URL}&$filter=docNo eq '${location.state?.rfpNo}'`,
    token,
  );

  console.log(BidLinesItemsData);

  const itemsList = BidLinesItemsData?.value || [];

  const refreshDropdownListeners = () => {
    const dropdownBtns = document.querySelectorAll(".sel-box");
    const dropdownConts = document.querySelectorAll(".dropdown-content");
    ////Console.log('Here are dropdown', dropdownConts);
    dropdownBtns.forEach((button, index) => {
      button.addEventListener("click", (event) => {
        dropdownConts.forEach((content) => (content.style.display = "none"));
        event.stopPropagation();
        dropdownConts[index].style.display = "block";
      });
    });

    document.addEventListener("click", (event) => {
      if (
        !event.target.classList.contains("sel-box") &&
        !event.target.closest(".dropdown-content")
      ) {
        dropdownConts.forEach((content) => {
          content.style.display = "none";
        });
      } else if (!event.target.closest(".dropdown-content")) {
        dropdownConts.forEach((content) => (content.style.display = "none"));
      }
    });
  };

  const refreshCheckboxListeners = () => {
    const seleCheckbox = document.querySelectorAll(".d-checkbox");
    const masterCheckbox = document.querySelector(".master-check");
    if (!masterCheckbox) return;

    const handleMasterChange = () => {
      seleCheckbox.forEach((checkbox) => {
        checkbox.checked = masterCheckbox.checked;
      });
    };

    const handleCheckboxChange = () => {
      masterCheckbox.checked = Array.from(seleCheckbox).every(
        (cb) => cb.checked,
      );
    };

    masterCheckbox.removeEventListener("change", handleMasterChange);
    masterCheckbox.addEventListener("change", handleMasterChange);

    seleCheckbox.forEach((checkbox) => {
      checkbox.removeEventListener("change", handleCheckboxChange);
      checkbox.addEventListener("change", handleCheckboxChange);
    });
  };

  useEffect(() => {
    refreshDropdownListeners();
    refreshCheckboxListeners();
  }, [lines]);

  const [showItemPopup, setShowItemPopup] = useState(false);
  const [selectedLineIndex, setSelectedLineIndex] = useState(null);

  const handleInputLineChange = async (index, field, value) => {
    const newLines = [...lines];
    newLines[index] = {
      ...newLines[index],
      [field]: value,
    };
    if (field === "quantity" || field === "unitCost") {
      const quantity = parseFloat(newLines[index].quantity) || 0;
      const unitPrice = parseFloat(newLines[index].unitCost) || 0;
      console.log(unitPrice);
      console.log(quantity);
      newLines[index].lineAmount = quantity * unitPrice;
    }
    console.log(newLines);
    setLines(newLines);
  };

  const handleLineChange = async (index, field, value) => {
    const newLines = [...lines];
    newLines[index] = {
      ...newLines[index],
      [field]: value,
    };

    if (field === "unitCost" || field === "quantity") {
      const quantity = parseFloat(newLines[index].quantity) || 0;
      const unitPrice = parseFloat(newLines[index].unitCost) || 0;
      newLines[index].lineAmount = (quantity * unitPrice).toFixed(2);
    }

    const requestBodyLine = {
      unitCost: parseInt(newLines[index].unitCost),
    };

    try {
      const headerResponse = await fetch(
        `${REACT_DATA_URL}bidlines(${newLines[index].systemId})?${REACT_APP_COMPANY_URL}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            "If-Match": "*",
            Authorization: `Basic ${token}`,
          },
          body: JSON.stringify(requestBodyLine),
        },
      );

      if (!headerResponse.ok) {
        throw new Error("Failed to save sales quote header");
      }
      const headerResult = await headerResponse.json();
      console.log("Sales quote header saved successfully:", headerResult);
      setLines(newLines);
    } catch (e) {
      console.log(e);
    }
  };

  const addNewLine = () => {
    setLines((prevLines) => [
      ...prevLines,
      {
        type: "",
        no: "",
        description: "",
        productLot: "",
        quantity: "",
        systemId: "",
        unitCost: "",
        uom: "",
        price: "",
      },
    ]);
  };

  useEffect(() => {
    refreshDropdownListeners();
    refreshCheckboxListeners();
  }, [lines]);

  useEffect(() => {
    refreshCheckboxListeners();
    refreshDropdownListeners();
    const inputs = document.querySelectorAll(".input-box");
    inputs.forEach((input) => {
      input.addEventListener("keydown", handleKeyDown);
    });
    return () => {
      inputs.forEach((input) => {
        input.removeEventListener("keydown", handleKeyDown);
      });
    };
  }, []);

  const handleKeyDown = (e) => {
    let row = e.target.parentElement.parentElement;
    let col = Array.from(row.children).indexOf(e.target.parentElement);
    let table = row.parentElement;

    if (e.target.value !== ":") {
      if (row.nextElementSibling === null && e.target.value.trim() !== "") {
        addNewLine();
      }
    }

    switch (e.key) {
      case "ArrowUp":
        if (row.previousElementSibling) {
          let target =
            row.previousElementSibling.children[col]?.querySelector(
              ".input-box",
            );
          if (target) target.focus();
        }
        break;
      case "ArrowDown":
        if (row.nextElementSibling) {
          let target =
            row.nextElementSibling.children[col]?.querySelector(".input-box");
          if (target) target.focus();
        }
        break;
      case "ArrowLeft":
        if (col > 0) {
          let target = row.children[col - 1]?.querySelector(".input-box");
          if (target) target.focus();
        }
        break;
      case "ArrowRight":
        if (col < row.children.length - 1) {
          let target = row.children[col + 1]?.querySelector(".input-box");
          if (target) target.focus();
        }
        break;
      case "Enter":
        e.target.value = calculate(e.target.value);
        break;
      default:
    }
  };

  const calculate = (input) => {
    try {
      return eval(input);
    } catch (error) {
      return input;
    }
  };

  const deleteLine = async (index) => {
    const newLines = [...lines];
    const requestBodyLine = newLines[index];
    await fetch(
      `${REACT_DATA_URL}bidlines(${newLines[index].systemId})?${REACT_APP_COMPANY_URL}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "If-Match": "*",
          Authorization: `Basic ${token}`,
        },
        body: JSON.stringify(requestBodyLine),
      },
    );
    newLines.splice(index, 1);
    setLines(newLines);
  };
  const deleteAllLines = async (bidNo) => {
    await fetch(
      `${REACT_APP_BIDDING_API_DATA_URL}deleteBidLines?${REACT_APP_COMPANY_URL}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${token}`,
        },
        body: JSON.stringify({ bidNo: bidNo }),
      },
    );
    setLines([]);
  };

  // CSV Download Function
  const downloadCSV = () => {
    const headers = [
      "Type",
      "No",
      "Description",
      "Product Lot",
      "Quantity",
      "Amount",
      "Unit of Measure",
    ];
    const rows = filteredItems.map((item) => [
      item.type,
      item.no,
      item.description,
      item.productLot,
      item.quantity,
      item.lineAmount,
      item.uom,
    ]);

    const csvContent = [
      headers.join(","),
      ...rows.map((row) => row.join(",")),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Bid_${location.state?.bidNo}_Items.csv`;
    link.click();
  };

  // Excel Download Function
  const downloadExcel = () => {
    const headers = [
      "Type",
      "No",
      "Description",
      "Unit of Measure",
      "Product Lot",
      "Quantity",
      "Unit Cost",
    ];
    const rows = filteredItems.map((item) => [
      item.type,
      item.no,
      item.description,
      item.uom,
      item.productLot,
      item.quantity,
      item.unitCost,
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Bid Items");
    XLSX.writeFile(workbook, `Bid_${location.state?.bidNo}_Items.xlsx`);
  };

  // PDF Download Function
  const downloadPDF = () => {
    const input = componentRef.current;
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      pdf.save(`Bid_${location.state?.bidNo}_Items.pdf`);
    });
  };

  const PrintableTable = () => (
    <div ref={componentRef} style={{ padding: "20px" }}>
      <h2>Bid Items - {location.state?.bidNo}</h2>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ py: 1 }}></TableCell>
              <TableCell sx={{ py: 1 }}>Type</TableCell>
              <TableCell sx={{ py: 1 }}>No</TableCell>
              <TableCell sx={{ py: 1 }}>Description</TableCell>
              <TableCell sx={{ py: 1 }}>Product Lot</TableCell>
              <TableCell sx={{ py: 1 }}>Quantity</TableCell>
              <TableCell sx={{ py: 1 }}>Unit Cost</TableCell>
              <TableCell sx={{ py: 1 }}>Unit of Measure</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredItems.map((item, index) => (
              <TableRow key={index}>
                <TableCell sx={{ py: 1 }}>
                  <Checkbox />
                </TableCell>
                <TableCell sx={{ py: 1 }}>{item.type}</TableCell>
                <TableCell sx={{ py: 1 }}>{item.no}</TableCell>
                <TableCell sx={{ py: 1 }}>{item.description}</TableCell>
                <TableCell sx={{ py: 1 }}>{item.productLot}</TableCell>
                <TableCell sx={{ py: 1 }}>{item.quantity}</TableCell>
                <TableCell sx={{ py: 1 }}>{item.unitCost}</TableCell>
                <TableCell sx={{ py: 1 }}>{item.uom}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
  const submitBid = (bidNo) => {
    Swal.fire({
      title: `<span style="font-size:1.1rem">Do you want to Submit the bid for processing?</span>`,
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const submitBidUrl = `${REACT_APP_BIDDING_API_DATA_URL}SubmitBid?${REACT_APP_COMPANY_URL}`;
        const bidNo = location.state?.bidNo;
        //Console.log(draftNumber);
        try {
          const response = await fetch(submitBidUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Basic ${token}`,
            },
            body: JSON.stringify({ bidNo: bidNo }),
          });
          if (response.ok) {
            // setFormData(prev => ({
            //   ...prev,
            //   confirm: true
            // }));
            Swal.fire("Bid submitted successfuly!", "", "success").then(() => {
              window.location.reload();
            });
          } else {
            Swal.fire("Error!", response.statusText, "error");
          }
        } catch (error) {
          console.error("Error Submiting bid:", error);
          Swal.fire("Error!", "Failed to submit Bid", "error");
        }
      } else if (result.isDismissed) {
        Swal.fire("Bid Submission cancelled", "", "info");
      }
    });
  };
  // Handle FIle Attachememt
  const makeAttachment = async (file, documentNo) => {
    // setIsModalLoading(true);
    if (!file) {
      Swal.fire("Error", "No file to Attach");
      // setIsModalLoading(false);
      return;
    }

    const fileContent = await convertFileToBase64(file);
    const fext = file.name;
    console.log("File extension:", fext); // Debug log

    const body = {
      FileName: file.name,
      fileType: fileContent.type,
      FileExtension: file.name.split(".").pop(),
      FileContentBase64: fileContent.split(",")[1],
      TableID: 50102,
      No: documentNo,
    };
    try {
      const response = await axios.post(
        `${REACT_DATA_URL}documentAttachments?${REACT_APP_COMPANY_URL}`,
        body,
        {
          headers: { Authorization: `Basic ${token}` },
        },
      );
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // Clear the file input
      }
      // setNewSelectedFile([]);
      setNewSelectedFile([]);
      await getDocumentAttachments(documentNo);
      console.log("Attachment response:", response.data); // Debug log
      Swal.fire("Success", "File attached successfully");
    } catch (error) {
      console.error("Error attaching file:", error);
      Swal.fire("Error", "Failed to attach file", "error");
    } finally {
      // setIsModalLoading(false);
    }
  };
  const getDocumentAttachments = async (documentNo) => {
    // setIsModalLoading(true);
    setNewSelectedFile((prevFiles) => {
      const updatedFiles = [...prevFiles];
      updatedFiles.splice(0);
      return updatedFiles;
    });

    try {
      const response = await axios.get(
        `${REACT_DATA_URL}documentAttachments?${REACT_APP_COMPANY_URL}&$filter=No eq '${documentNo}' and TableID eq 50102`,
        {
          headers: { Authorization: `Basic ${token}` },
        },
      );
      console.log("Attachments:", response.data); // Debug log
      setSelectedFile(response.data.value);
      setNewSelectedFile([]);
    } catch (error) {
      console.error("Error fetching attachments:", error);
      Swal.fire("Error", "Failed to load attachments", "error");
    } finally {
      // setIsModalLoading(false);
    }
  };
  const downloadAttachment = async (systemId) => {
    // setIsModalLoading(true);
    try {
      const response = await axios.get(
        `${REACT_DATA_URL}documentAttachments(${systemId})?${REACT_APP_COMPANY_URL}`,
        {
          headers: { Authorization: `Basic ${token}` },
        },
      );
      // console.log('Attachment response:', response.data.FileName); // Debug log
      const ext = response.data?.FileExtension;
      const blob = base64ToBlob(response.data?.FileContentBase64, ext);
      // console.log(blob);
      // console.log(ext);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${systemId}.${ext}`; // Set the desired file name
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error downloading attachment:", error);
    } finally {
      // setIsModalLoading(false);
    }
  };

  const removeAttachment = (systemId, documentNo) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        // setIsModalLoading(true)
        axios
          .delete(
            `${REACT_DATA_URL}documentAttachments(${systemId})?${REACT_APP_COMPANY_URL}`,
            {
              headers: {
                Authorization: `Basic ${token}`,
              },
            },
          )
          .then((r) => {
            getDocumentAttachments(documentNo);
            // setIsModalLoading(false);
          })
          .catch((e) => {
            // setIsModalLoading(e)
          });
      }
    });
  };
  const handleSelectedFiles = (e) => {
    const files = e.target.files;
    setNewSelectedFile(Array.from(files));
  };

  const handleUploadExcel = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const reader = new FileReader();

    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      const filteredData = jsonData.filter((row) =>
        row.some((cell) => cell !== null && cell !== ""),
      );

      // Map all fields from Excel to the API structure
      const newLines = filteredData.slice(1).map((row) => ({
        systemId: row[0] || "",
        type: row[1] || "",
        no: row[2] || "",
        description: row[3] || "",
        uom: row[4] || "",
        productLot: row[5] || "",
        quantity: row[6] || 0,
        unitCost: parseFloat(row[7]?.toString().trim()) || 0,
        VatProdGr: row[8] || "",
        documentType: row[9] || "",
        lineNo: row[10] || 0,
        documentNo: row[11] || "",
        ndaRegistrationNo: String(row[12]) || "",
        manufactureProductDescription: row[13] || "",
        brandName: row[14] || "",
        manufacturer: row[15] || "",
        countryOfOrigin: row[16] || "",
        supplierCurrency: row[17] || "",
        cfrKampalaUnitPrice: row[18] || 0,
        paymentTerms: row[19] || "",
        prepaymentPercentage: row[20] || 0,
        leadTimeForExWorksInDays: parseInt(row[21]?.toString().trim()) || 0,
        leadTimeForFreshProdInDays: parseInt(row[22]?.toString().trim()) || 0,
        totalShelfLifeOfProduct: row[23] || "",
        qtyPerCarton: row[24] || 0,
        cartonDimension: row[25] || "",
        weightPerCarton: row[26] || 0,
        volumePerCarton: row[27] || 0,
        cartonsPerPallets: row[28] || 0,
        noOfPallets: parseInt(row[29]?.toString().trim()) || 0,
        noOfContainers: parseInt(row[30]?.toString().trim()) || 0,
        ddpJmsUnitPrice: parseFloat(row[31]?.toString().trim()) || 0,
        exUnitPrice: parseFloat(row[32]?.toString().trim()) || 0,
        comentOrRemark: row[33] || "",
        isBUBU: row[34],
        isCosignment: row[35],
        lineAmount: parseFloat(row[6] || 0) * parseFloat(row[7] || 0) || 0,
      }));

      console.log("Parsed lines:", newLines);

      const invalidLines = newLines.filter((line) => {
        const existsInItemsList = itemsList.some(
          (item) => item.systemId === line.id,
        );
        return !existsInItemsList;
      });

      if (invalidLines.length > 0) {
        alert(
          `The following lines don't belong to this bid:\n${invalidLines.map((line) => `Item No: ${line.no}`).join("\n")}`,
        );
        return;
      }

      try {
        for (const line of newLines) {
          const requestBodyLine = {
            documentNo: location.state?.bidNo,
            documentType: line.documentType,
            lineNo: parseInt(line.lineNo),
            type: line.type,
            no: line.no,
            // buyFromVendorType: location.state?.buyFromVendorType || '',
            // vendorNo: sessionStorage.getItem('vendorNo') || '',
            description: line.description,
            productLot: line.productLot,
            uom: line.uom,
            quantity: parseFloat(line.quantity),
            VatProdGr: line.VatProdGr,
            unitCost: parseFloat(line.unitCost),
            ndaRegistrationNo: line.ndaRegistrationNo,
            manufacturer: line.manufacturer,
            manufactureProductDescription: line.manufactureProductDescription,
            brandName: line.brandName,
            countryOfOrigin: line.countryOfOrigin,
            supplierCurrency: line.supplierCurrency,
            pmtTerms: line.paymentTerms,
            prepaymentPercentage: line.prepaymentPercentage,
            leadTimeXWorks: parseInt(line.leadTimeForExWorksInDays),
            leadTimeFreshProdinDays: parseInt(line.leadTimeForFreshProdInDays),
            totalShelfLifeProd: line.totalShelfLifeOfProduct,
            qtyperCarton: parseInt(line.qtyPerCarton),
            cartonDimension: line.cartonDimension,
            noOfPallets: parseInt(line.noOfPallets),
            noOfContainers: parseInt(line.noOfContainers),
            weightPerCarton: parseFloat(line.weightPerCarton),
            volPerCarton: parseFloat(line.volumePerCarton),
            cartonsPerPallet: parseInt(line.cartonsPerPallets),
            exUnitPrice: parseFloat(line.exUnitPrice),
            ddpJmsUnitPrice: parseFloat(line.ddpJmsUnitPrice),
            comentOrRemark: line.comentOrRemark,
            isBUBU: String(line.isBUBU).toLowerCase(),
            isCosignment: String(line.isCosignment).toLowerCase(),
          };

          console.log("Uploading line:", requestBodyLine);

          const lineResponse = await fetch(
            `${REACT_DATA_URL}bidlines?${REACT_APP_COMPANY_URL}`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: `Basic ${token}`,
                "If-Match": "*",
              },
              body: JSON.stringify(requestBodyLine),
            },
          );

          if (!lineResponse.ok) {
            const errorData = await lineResponse.json();
            console.error("Error details:", errorData);
            throw new Error(`Failed to save bid item: ${line.no}`);
          }

          const lineResult = await lineResponse.json();
          console.log("Upload successful:", lineResult);
        }

        setLines(
          lines.some((line) => Object.values(line).some((val) => val !== ""))
            ? [...lines, ...newLines]
            : newLines,
        );
        alert("All lines uploaded successfully!");
      } catch (error) {
        console.error("Error uploading lines:", error);
        alert(`Error uploading lines: ${error}`);
      }
    };

    reader.readAsArrayBuffer(file);
  };

  return (
    <Container sx={{ mt: 4, mb: 4 }}>
      {/* Bid Details Section */}
      <Box component="form" noValidate autoComplete="off" sx={{ mb: 4 }}>
        <Grid container spacing={2}>
          {/* First Row */}
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="No"
              variant="outlined"
              // value={location.state?.bidNo}
              value={lvBidHeader?.no}
              InputProps={{ readOnly: true }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="RFP No"
              variant="outlined"
              // value={location.state?.rfpNo}
              value={lvBidHeader?.rfpNo}
              InputProps={{ readOnly: true }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Document Date"
              variant="outlined"
              // value={location.state?.bidPostingDate}
              value={lvBidHeader?.postingDate}
              InputProps={{ readOnly: true }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Valid To Date"
              variant="outlined"
              // value={location.state?.bidDueDate}
              value={lvBidHeader?.validToDate}
              InputProps={{ readOnly: true }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          {/* Second Row */}
          <Grid item xs={12} sm={9}>
            <TextField
              fullWidth
              size="small"
              label="Subject of Procurement"
              variant="outlined"
              rows={3}
              // value={location.state?.bidDescription}
              value={lvBidHeader?.description}
              InputProps={{ readOnly: true }}
              InputLabelProps={{ shrink: true }}
              sx={{ mt: 2 }} // Add margin-top for better spacing
            />
          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            <TextField
              fullWidth
              size="small"
              label="Status"
              variant="outlined"
              // value={location.state?.bidStatus}
              value={lvBidHeader?.Status}
              InputProps={{ readOnly: true }}
              InputLabelProps={{ shrink: true }}
              sx={{ mt: 2 }}
            />
          </Grid>
        </Grid>
      </Box>

      <Divider sx={{ mb: 4, color: "black", height: 3 }} />

      {/* Search Bar and Download Buttons */}
      <Box sx={{ mb: 2 }}>
        <Grid container spacing={2} alignItems="center">
          {/* Search Section */}
          <Grid item xs={12} sm={8} md={6} lg={6}>
            <Box display="flex" alignItems="center">
              <FormControl
                variant="outlined"
                size="small"
                sx={{ mr: 2, minWidth: 120 }}
              >
                <InputLabel>Search By</InputLabel>
                <Select
                  value={searchColumn}
                  onChange={(e) => setSearchColumn(e.target.value)}
                  label="Search By"
                >
                  <MenuItem value="no">No</MenuItem>
                  <MenuItem value="type">Description</MenuItem>
                  <MenuItem value="lineNo">ProductLot</MenuItem>
                </Select>
              </FormControl>
              <TextField
                variant="outlined"
                placeholder="Search items..."
                size="small"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                fullWidth
              />
            </Box>
          </Grid>

          {/* Buttons Section */}
          <Grid item xs={12} sm={4} md={6} lg={6}>
            <Box
              display="flex"
              justifyContent="flex-end"
              flexWrap="wrap"
              gap={1}
            >
              <input
                type="file"
                accept=".xlsx, .xls"
                onChange={handleUploadExcel}
                style={{ display: "none" }}
                id="upload-excel"
              />

              <Button
                variant="contained"
                sx={{ backgroundColor: "#5C2626" }}
                onClick={() => document.getElementById("upload-excel").click()}
              >
                Upload Excel
              </Button>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#5C2626" }}
                onClick={downloadExcel}
              >
                Excel
              </Button>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#5C2626" }}
                onClick={() => setOpenPreview(true)}
              >
                PDF
              </Button>

              <Button
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
                variant="contained"
                sx={{ backgroundColor: "#5C2626" }}
                onClick={() => getDocumentAttachments(location.state?.bidNo)}
              >
                Attach
              </Button>

              <Button
                variant="contained"
                sx={{ backgroundColor: "#5C2626" }}
                onClick={() => submitBid(location.state?.bidNo)}
              >
                Submit
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
      {/* {attShow && ( */}
      <div
        className="modal fade"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Attachments
              </h5>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
            <div className="modal-body">
              <Row className="mb-2">
                <Col md={6} sm={12}>
                  <div className="mb-3">
                    <label htmlFor="floatingnameInput" className="mb-1">
                      Attach File
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={(e) => handleSelectedFiles(e)}
                      ref={fileInputRef}
                    />
                  </div>
                </Col>
                <Col md={4}></Col>
                <Col md={2} sm={12}>
                  <a
                    href="#15"
                    className="btn btn-sm border-black action-btn mt-4"
                    onClick={(e) => {
                      e.preventDefault();
                      makeAttachment(newSelectedFile[0], location.state.bidNo);
                    }}
                  >
                    Attach
                  </a>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md={12}>
                  {selectedFile.length > 0 || newSelectedFile.length > 0 ? (
                    <div className="table-responsive">
                      <Table className="table table-striped table-sm mb-4">
                        <thead>
                          <tr>
                            <th>No</th>
                            <th>File</th>
                            <th>Remove</th>
                          </tr>
                        </thead>
                        <tbody>
                          {newSelectedFile.map((a, k) => (
                            <tr key={k}>
                              <td style={{ verticalAlign: "middle" }}>
                                {k + 1}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                {a.name}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                <div className="d-flex gap-3">
                                  {/* <Link
                                                              to="#"
                                                              className="text-danger"
                                                              // onClick={() => removeFile(k)}
                                                          >
                                                              Remove
                                                          </Link> */}
                                </div>
                              </td>
                            </tr>
                          ))}
                          {selectedFile.map((a, k) => (
                            <tr key={k} className="py-1">
                              <td style={{ verticalAlign: "middle" }}>
                                {k + 1}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                <Link
                                  to="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    downloadAttachment(a.SystemId);
                                  }}
                                >
                                  {a.FileName}
                                </Link>
                              </td>
                              <td
                                style={{
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                }}
                              >
                                {" "}
                                <>
                                  <div className="d-flex gap-3">
                                    <Link
                                      to="#10"
                                      className="text-danger"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        removeAttachment(a.SystemId, a.no);
                                      }}
                                    >
                                      Remove
                                    </Link>
                                  </div>
                                </>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  ) : (
                    <div className="text-center">
                      <div className="mb-4">
                        <i className="mdi mdi-file-question text-warning display-4" />
                      </div>
                      <h6>No file attached</h6>
                    </div>
                  )}
                </Col>
              </Row>
            </div>
            <div className="modal-footer">
              {/* <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> */}
              {/* <button type="button" class="btn btn-primary">Save changes</button> */}
            </div>
          </div>
        </div>
      </div>

      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2-content"
          id="panel2-header"
          style={{
            color: "#333",
            borderBottom: "1px solid #000000",
            margin: 0,
            fontWeight: 800,
          }}
        >
          Bid Items Lines
        </AccordionSummary>
        <AccordionDetails>
          <div className="ListPart">
            <div className="input-Area">
              <table id="myTable">
                <thead>
                  <tr>
                    <th className="fixed-col"></th>
                    <th className="select-check fixed-col">
                      <input
                        className="master-check"
                        type="checkbox"
                        aria-label="sel"
                      />
                    </th>
                    <th className="fixed-col">Type</th>
                    <th className="fixed-col"></th>
                    <th>No</th>
                    <th>Description</th>
                    <th>Unit of Measure</th>
                    <th>Product Lot</th>
                    <th>Quantity</th>
                    <th>Unit Price</th>
                    <th>LineAmount</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {lines.map((line, index) => (
                    <tr key={index}>
                      <td className="active-line fixed-col"></td>
                      <td className="hide-checkbox fixed-col">
                        <input
                          type="checkbox"
                          className="d-checkbox"
                          aria-label="Type"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          className="input-box"
                          aria-label="Lname"
                          disabled
                          value={line.type}
                          onChange={(e) =>
                            handleLineChange(index, "type", e.target.value)
                          }
                        />
                      </td>
                      <td className="dropdown fixed-col">
                        <input
                          type="button"
                          className="input-box sel-box"
                          value=":"
                        />
                        <div className="dropdown-content">
                          <a onClick={() => deleteLine(index)}>Delete Line</a>
                          <a
                            onClick={() => deleteAllLines(location.state.bidNo)}
                          >
                            Delete All Lines
                          </a>
                        </div>
                      </td>
                      <td>
                        <input
                          type="text"
                          className="input-box"
                          value={line.no}
                          onFocus={() => {
                            setSelectedLineIndex(index);
                            setShowItemPopup(true);
                          }}
                          onChange={(e) =>
                            handleLineChange(index, "no", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          className="input-box"
                          aria-label="JobTitle"
                          disabled
                          value={line.description}
                          onKeyDown={handleKeyDown}
                          onChange={(e) =>
                            handleLineChange(
                              index,
                              "description",
                              e.target.value,
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          className="input-box"
                          aria-label="JobTitle"
                          value={line.uom}
                          disabled
                          onKeyDown={handleKeyDown}
                          onChange={(e) =>
                            handleInputLineChange(index, "uom", e.target.value)
                          }
                          onBlur={(e) =>
                            handleLineChange(index, "uom", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          className="input-box"
                          aria-label="JobTitle"
                          disabled
                          onKeyDown={handleKeyDown}
                          value={line.productLot}
                          onChange={(e) =>
                            handleLineChange(
                              index,
                              "productLot",
                              e.target.value,
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          className="input-box"
                          aria-label="JobTitle"
                          disabled
                          value={line.quantity}
                          onKeyDown={handleKeyDown}
                          onChange={(e) =>
                            handleInputLineChange(
                              index,
                              "quantity",
                              e.target.value,
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          className="input-box"
                          aria-label="JobTitle"
                          value={line.unitCost}
                          onKeyDown={handleKeyDown}
                          onChange={(e) =>
                            handleInputLineChange(
                              index,
                              "unitCost",
                              e.target.value,
                            )
                          }
                          onBlur={(e) =>
                            handleLineChange(index, "unitCost", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          className="input-box"
                          aria-label="JobTitle"
                          disabled
                          value={line.lineAmount}
                          onKeyDown={handleKeyDown}
                          onChange={(e) =>
                            handleInputLineChange(
                              index,
                              "lineAmount",
                              e.target.value,
                            )
                          }
                        />
                      </td>
                      <td></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </AccordionDetails>
      </Accordion>

      {/* PDF Preview Dialog */}
      <Dialog
        open={openPreview}
        onClose={() => setOpenPreview(false)}
        maxWidth="lg"
      >
        <DialogTitle>PDF Preview</DialogTitle>
        <DialogContent>
          <PrintableTable />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenPreview(false)}>Cancel</Button>
          <Button onClick={downloadPDF} color="primary">
            Download PDF
          </Button>
        </DialogActions>
      </Dialog>
      <style>
        {`
          ::placeholder { color: black; }
          *{ padding:0px; margin:0px; box-sizing: border-box; }
          body{ height:100vh; width: 100vw; display:flex; justify-content: center; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; }
          .input-box{ width:100%; border: none; outline: none; box-shadow: none; padding: 3px 5px; height: 100%; }
          a{ text-decoration: none; }
          form>input{ outline: none; border:1.5px solid gray; height:25px; border-radius: 4px; padding:0px 5px; }
          .ListPart{ margin: 10px 0px; width:88vw; height: 100%; display: flex; align-items:center ; flex-direction: column; font-size: 13.5px; }
          .ListPartHdr,.ListPartActions{ margin:0px 3%; width:100%; height:38px; display:flex; align-items: center; gap:20px; padding-bottom: 3px; border-top: 1.2px solid gray; border-bottom: 1.2px solid gray; list-style-type: none; }
          .ListPartHdr>li:hover{ border-bottom: 2px solid rgb(83, 117, 137); color: rgb(67, 115, 115); cursor: pointer; }
          .ListPartActions>li:hover{ color: rgb(67, 115, 115); cursor: pointer; }
          .input-Area{ width:100%; scrollbar-width: thin; overflow-x: scroll; }
          .helper-icons{ margin-left: auto; }
          table{ width:100%; min-width: 550px; margin-top: 5px; margin-bottom: 30px; padding:0px 3%; border-collapse: collapse; text-align: left; }
          th{ font-weight:lighter; color:rgb(65, 60, 60); }
          table>thead>tr>th{ font-family: 'Lato', sans-serif; width:max-content; font-size: larger; font-weight: 400; background:#eeeeec; height:30px; }
          table>tbody>tr>td{ border:1px solid rgb(151, 151, 151); }
          table>tbody>tr>td>input:focus{ border:2px solid rgb(123, 139, 164); }
          table>tbody>tr>td:nth-child(2){ padding: 0px 8px; }
          table>thead>tr>:last-child{ width:30px; }
          table>thead>tr>:first-child{ border-left: none; }
          table>tbody>tr{ height:25px; font-size: small; border-bottom: 1px solid gray; }
          .sel-box{ background:none; display: flex; width:100%; height:100%; justify-content: center; }
          .master-check{ background: none; }
          .dropdown-content { display: none;position: absolute; background-color: #f9f9f9; min-width: 100px; box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2); z-index: 1; right: 0; }
          .dropdown-content-dots { display: none; position: absolute; background-color: #f9f9f9; min-width: 100px; box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2); z-index: 1; right: 0; }
          .dropdown-content a { color: black; padding: 5px 2px; text-decoration: none; display: block; text-align: left; }
          .dropdown:hover .dropbtn { background-color: #3e8e41; }
          .dropdown-content a:hover {background-color:rgb(101, 100, 100)}
          table>tbody>tr>:nth-child(1){ font-size: 20px; }
          table>thead>tr>:first-child,table>tbody>tr>:first-child{ width: 30px; text-align: center; }
          .dropdown:hover{ background:lightseagreen; cursor: pointer; }
          .popup{ display:none; }
          .select-check{ padding: 0px 8px; }
          input[type="checkbox"] { width: 12px; height: 12px; background-color: transparent; }
          .column-filter { display: inline-block; position: relative; margin-left: 5px; cursor: pointer; }
          .column-filter>i{ color: rgb(91, 90, 90); }
          .filter-dropdown { display: none; position: absolute; background-color: #fff; min-width: 100px; box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2); z-index: 1; right: 0; }
          .column-filter:hover .filter-dropdown { display: block; }
          .filter-dropdown a { color: black; padding: 5px 10px; text-decoration: none; display: block; }
          .filter-dropdown a:hover { background-color: #cecaca; }
        `}
      </style>
      {showItemPopup && (
        <ItemSearchPopup
          items={itemsList}
          initialSearchTerm={lines[selectedLineIndex]?.itemNo}
          onSelectItem={async (selectedItem) => {
            console.log("Hello item" + selectedItem);
            if (selectedLineIndex !== null) {
              const existingItem = lines.find(
                (line) => line.no === selectedItem.no,
              );
              if (existingItem) {
                alert("Item already exists in the lines");
                setShowItemPopup(false);
                return;
              }
              const updatedLines = [...lines];
              try {
                const requestBodyLine = {
                  type: "Item",
                  no: selectedItem.no,
                  description: selectedItem.description,
                  productLot: selectedItem.productLot,
                  quantity: selectedItem.Quantity,
                  uom: selectedItem.uom,
                  price: selectedItem.price,
                  documentNo: location.state?.bidNo,
                  vendorNo: sessionStorage.getItem("vendorNo"),
                  buyFromVendorType: location.state?.buyFromVendorType,
                };
                console.log(requestBodyLine);
                console.log(selectedItem);
                const lineResponse = await fetch(
                  `${REACT_DATA_URL}bidlines?${REACT_APP_COMPANY_URL}`,
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Accept: "application/json",
                      Authorization: `Basic ${token}`,
                      "If-Match": "*",
                    },
                    body: JSON.stringify(requestBodyLine),
                  },
                );
                if (!lineResponse.ok) {
                  throw new Error(`Failed to save bid item`);
                }
                const lineResult = await lineResponse.json();
                console.log(lineResult);
                updatedLines[selectedLineIndex] = {
                  ...updatedLines[selectedLineIndex],
                  type: selectedItem.type,
                  no: selectedItem.no,
                  description: selectedItem.description,
                  uom: selectedItem.uom || "",
                  productLot: selectedItem.productLot,
                  quantity: selectedItem.Quantity,
                  unitCost: selectedItem.unitCost || 0,
                  systemId: lineResult.id,
                };
                setLines(updatedLines);

                // Add a new empty line after the current line
                addNewLine();
              } catch (e) {
                //Console.log(e);
              }
            }
            setShowItemPopup(false);
          }}
          onClose={() => setShowItemPopup(false)}
        />
      )}
    </Container>
  );
};

export default ApplyBidDetailsPage;
